<script lang="ts">
    import IconImg from "./IconImg.svelte";
    import phone from "../icons/PhoneIcon.svelte";
    export let text: string;
    const toTelLink = (tel: string): string => tel.match(/\d+/g).join("");
</script>

<a class="icon-link" href="tel:+{toTelLink(text)}">
    <IconImg svg={phone} />
    {text}
</a>
